import { render, staticRenderFns } from "./ScriptoriumTable.vue?vue&type=template&id=3a1d6280&scoped=true&"
import script from "./ScriptoriumTable.vue?vue&type=script&lang=js&"
export * from "./ScriptoriumTable.vue?vue&type=script&lang=js&"
import style0 from "./ScriptoriumTable.vue?vue&type=style&index=0&id=3a1d6280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1d6280",
  null
  
)

export default component.exports